(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/digital-tickets/utils.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/digital-tickets/utils.js');
const { formatOrgNumber } = svs.ticket_partner.utils;
const digitalOrderModel = {
  customer: {
    partnerId: 0,
    retailerStatus: 2,
    eMail: '',
    contactPerson: '',
    companyName: '',
    legalCompanyName: '',
    organizationNumber: '',
    phone: '',
    supportPhone: '',
    cellPhone: '',
    userTermsApproved: true,
    invoiceDueDays: 15,
    discountType: null,
    isPartner: false,
    addresses: [],
    billing: {
      addressType: 'Billing',
      contact: '',
      phone: '',
      email: '',
      address1: '',
      address2: '',
      zip: '',
      city: '',
      countryId: ''
    }
  },
  order: {
    message: '',
    invoiceMessage: '',
    orderId: '',
    ordererType: 'Ftg',
    rows: []
  }
};

const createBillingObject = ({ reference, address1, zip, city, countryId }, { eMail, phone }) => {
  return {
    addressType: 'Billing',
    contact: reference,
    phone,
    email: eMail,
    address1,
    address2: '',
    zip: zip.replaceAll(' ', ''),
    city,
    countryId: countryId.toString()
  };
};

const createOrder = (articles, invoiceMessage, message) => {
  return {
    invoiceMessage,
    message,
    ordererType: 'Ftg',
    orderId: '',
    rows: Object
      .values(articles)
      .map(({ articleId, count }) => ({ articleId, count: parseInt(count, 10) }))
      .filter(({ count }) => count > 0)
  };
};

const createDigitalOrderRequest = ({ billingInformation, registerNew, articles }, companyDetails = null) => {
  const { address1, zip, city, countryId, invoiceMessage, message } = billingInformation;
  const { contactPerson, phone, eMail, organizationNumber } = registerNew;
  const order = createOrder(articles, invoiceMessage, message);
  const billing = createBillingObject(billingInformation, registerNew);
  if (companyDetails) {
    return {
      ...digitalOrderModel,
      customer: {
        ...digitalOrderModel.customer,
        ...companyDetails,
        billing
      },
      order
    };
  }

  const addresses = ['Billing', 'Legal', 'Visiting'].map((addressType) => {
    return {
      addressType,
      contact: contactPerson,
      phone: phone || '',
      email: eMail || '',
      address1,
      address2: '',
      zip: zip.replaceAll(' ', ''),
      city,
      countryId: countryId.toString()
    };
  });

  return {
    ...digitalOrderModel,
    customer: {
      ...digitalOrderModel.customer,
      ...registerNew,
      organizationNumber: formatOrgNumber(organizationNumber.replace('-', ''), false),
      supportPhone: phone,
      addresses,
      billing
    },
    order
  };
};

svs.ticket_partner.digitalTickets.utils = {
  createDigitalOrderRequest
};



 })(window);